import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { GraphQLCommitmentParticipant } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CalendarIcon } from '../../atoms/calendar-icon/calendar-icon.tsx';
import { ReminderAlert } from '../reminder-alert/reminder-alert.tsx';
export type ReminderAlertBirthdayProps = {
  ctaHref: string;
  participant: GraphQLCommitmentParticipant;
};
export const ReminderAlertBirthday: React.FC<ReminderAlertBirthdayProps> = t0 => {
  const $ = _c(18);
  const {
    ctaHref,
    participant
  } = t0;
  const {
    t
  } = useTranslation("my");
  let t1;
  if ($[0] !== t) {
    t1 = t("my:reminderAlert.give.cta");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ctaHref || $[3] !== t1) {
    t2 = {
      href: ctaHref,
      text: t1
    };
    $[2] = ctaHref;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== participant.birthdate) {
    t3 = participant.birthdate ? <CalendarIcon date={participant.birthdate} /> : null;
    $[5] = participant.birthdate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = participant.gender ?? undefined;
  let t5;
  if ($[7] !== t || $[8] !== t4) {
    t5 = t("my:primaryCtaBirthday.default.subtitle", {
      count: 1,
      context: t4
    });
    $[7] = t;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== participant.name || $[11] !== t) {
    t6 = t("my:reminderAlert.title", {
      name: participant.name
    });
    $[10] = participant.name;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <ReminderAlert cta={t2} icon={t3} subtitle={t5} title={t6} />;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};